<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-03-07 09:31:00
 * @LastEditors: may.li
 * @LastEditTime: 2023-06-12 14:21:27
-->
<template>
	<div class="page page_fans page_adress page-agent-add">
		<van-search	v-model="keyword" show-action shape="round" placeholder="请输入搜索关键词">
			<template #action>
				<div @click="onSearch">搜索</div>
			</template>
		</van-search>
		<div class="sorce-wrap">
			<div class="wrap-title">匠人来源</div>
			<div class="sorce-list">
				<div :class="item.isSelect ? 'item-name active' : 'item-name '" v-for="(item,index) in sorceList" :key="index" @click="selectSorce(item)">{{ item.title }}</div>
			</div>
		</div>
		<div class="" v-if="showResult">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getTradesmanList">
				<div class="list">
					<div class="item" v-for="item in tradesList" :key="item.user_uuid">
						<div class="item_l">
							<img :src="item.thumb ? ($publicData.withHttpStart(item.thumb) ? item.thumb : imageUrl+item.thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
							<div class="user_name slh_s">{{ item.nickname }}</div>
						</div>
						<div class="item_r">
							<div class="action" @click="addAgent(item)">代理</div>
						</div>
					</div>
				</div>
			</van-list>
		</div>
		<!-- loading -->
		<van-overlay :show="showLoading">
            <div class="wrapper-loading">
				<van-loading type="spinner" />
			</div>
        </van-overlay>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			page: 1,
			size: 12,
			loading: false,
			finished: false,
			tradesList: [],
			keyword: null,
			sorceList: [],
			sorceId: null,
			showLoading: false,
			showResult: false, // 默认显示
			imageUrl: this.$publicData.uploadImage
		}
	},
	beforeRouteEnter(to,from,next){
		next(vm=>{
			vm.showResult = false;
		})
	},
	created() {
		this.token = this.$store.getters.token;
		this.getSorceList();
	},
	watch: {
		// 'keyword': function(val){
		// 	if(!val){
		// 		this.page = 1;
		// 		this.tradesList = [];
		// 		this.loading = true;
		// 		this.finished = false;
		// 		this.getTradesmanList();
		// 	}
		// }
	},
	methods: {
		/**
		 * @name: 点选来源
		 * @param {*} item
		 * @return {*}
		 * @desc: 
		 */		
		selectSorce(item){
			let list = this.sorceList;
			if(!item.isSelect){
				this.sorceId = item.id;
				this.page = 1;
				this.tradesList = [];
				this.loading = true;
				this.finished = false;
				this.showResult = true;
				this.getTradesmanList();
			};
			for(let i in list){
				if(list[i].id == item.id){
					if(item.isSelect){
						list[i].isSelect = false;
					}else{
						list[i].isSelect = true;
					}
				}else{
					list[i].isSelect = false;
				}
			};
			this.sorceList = list;
		},
		/**
		 * @name: 获取匠人来源
		 * @return {*}
		 * @desc: 
		 */		
		getSorceList(){
			let params = {
				token: this.token
			};
			this.$api.tradesman.sorcelist(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					for(let i in list){
						list[i].isSelect = false;
						this.sorceList.push(list[i]);
					}
				}
			})
		},
		/**
		 * @name: 搜索
		 * @return {*}
		 * @desc: 
		 */		
		onSearch(){
			if(!this.keyword){
				this.$toast("请输入搜索词");
				return;
			};
			this.page = 1;
			this.tradesList = [];
			this.loading = true;
			this.finished = false;
			this.showResult = true;
			this.getTradesmanList();
		},
		/**
		 * @name: 添加
		 * @param {*} item
		 * @return {*}
		 * @desc: 
		 */		
		addAgent(item){
			let params = {
				token: this.token,
				trades_uuid: item.uuid
			};
			this.showLoading = true;
			this.$api.my.agentAddTradesman(params).then(res=>{
				this.showLoading = false;
				if(res.code == 200){
					this.$toast('添加成功');
                    this.page = 1;
					this.dataList = [];
					this.loading = true;
					this.finished = false;
					this.showResult = true;
					this.getTradesmanList();
				}
			})
		},
		/**
		 * @name: 获取可添加的匠人列表
		 * @return {*}
		 * @desc: 
		 */		
		getTradesmanList(){
			let params = {
                token: this.token,
                page: this.page,
                size: this.size
            };
			if(this.keyword){
				params.keyword = this.keyword;
			};
			if(this.sorceId){
				params.sorce = this.sorceId;
			};
			this.showLoading = true;
			this.$api.my.agentTradesman(params).then(res=>{
				if(res.code == 200){
					let list = res.result;
					if(list.length){
						if(this.page == 1){
							this.tradesList = list;
						}else{
							for(let i in list){
								this.tradesList.push(list[i]);
							};
						};
						if(list.length < this.size){
							this.finished = true;
						}else{
							this.page++;
							this.loading = false;
						}
					}else{
						this.finished = true;
					};
					this.showLoading = false;
				}else{
					this.finished = true;
					this.showLoading = false;
				}
			})
		}
	},
}
</script>
<style scoped>
	.page_fans .list .item .action{
		background: rgba(244, 244, 244, 1);
    	color: rgba(0, 0, 0, 0.54);
	}
	.wrapper-loading{
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
	}
</style>